



// export const isDevMode =
//    !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const REACT_APP_PRIVATE_KEYCLOAK_AUTH_URL = import.meta.env.VITE_REACT_APP_PRIVATE_KEYCLOAK_AUTH_URL || '';

export const BASE_URL = import.meta.env.VITE_REACT_APP_API_BASE_URL || '';

export const INFLIGHT_URL = import.meta.env.VITE_REACT_APP_INFLIGHT_API_URL || '';



export const CLIENT_SECRET =import.meta.env.VITE_REACT_APP_KEYCLOAK_CLIENT_SERCET || '';

export const CLIENT_ID = import.meta.env.VITE_REACT_APP_KEYCLOAK_PRIVATE_CLIENT_ID || '';
